/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch } from 'react-redux'
import { MapShareDrawer as Drawer } from 'ui-components'

import { useHandleInfographic } from '~map-preview/hooks/useHandleInfographic'
import { useIsShareAllowed } from '~map-preview/hooks/useIsShareAllowed'
import { setIsInfographic } from '~map-preview/states/infographic'
import {
  closeMapShareDrawer,
  useIsMapShareDrawerOpen
} from '~map-preview/states/ui'
import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'
import { useEffect } from 'react'
import { Embed } from './Embed'
import { Infographic } from './Infographic'
import { Share } from './Share'

function MapShareDrawer() {
  const isEmbed = useIsEmbed()
  const dispatch = useDispatch()

  const open = useIsMapShareDrawerOpen()

  useHandleInfographic()
  const isShareAllowed = useIsShareAllowed()

  const handleClose = () => {
    dispatch(closeMapShareDrawer())
  }

  const handleTabChange = (tab: string) => {
    dispatch(setIsInfographic(tab === 'infographic'))
  }

  // :note: we make sure to set the infographic state to false when the drawer is closed
  useEffect(() => {
    if (!open) {
      dispatch(setIsInfographic(false))
    }
  }, [open])

  if (!isShareAllowed) return null

  return (
    <Drawer
      isEmbed={isEmbed}
      open={open}
      onClose={handleClose}
      onTabChange={handleTabChange}
      slots={{
        Share,
        Infographic,
        Embed
      }}
    />
  )
}

export { MapShareDrawer }
